import "antd/dist/antd.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { Card, Col, Row, Spin, Image, List, Button, Divider } from "antd";
import { useEffect, useState, useRef, useCallback } from "react";
import {
    SearchOutlined, SettingOutlined, RightOutlined, MenuOutlined, UnlockOutlined, PlusOutlined, EditOutlined, ContactsOutlined, PlusSquareOutlined, UserOutlined, PhoneFilled, MailFilled, FileExcelOutlined, DeleteOutlined, TeamOutlined, FormOutlined, SkinOutlined, CheckOutlined
} from "@ant-design/icons";
import moment from "moment";
import { useHistory } from "react-router-dom";
import axiosClient from "../../api/axios";

import News from "../News/news";
import Fanpage from "../Fanpage/fanpage";
import Organization from "../Organization/Organization";





const Work = () => {

    return (
        <div style={{ backgroundColor: '#FFFFFF' }}>
            <Organization />
        </div>
    )
}
export default Work;